import { Injectable } from '@angular/core';
import { throwError, of, Observable, Subject, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FnMenuItemState, FnMenuState } from '../models/fn-menu.state';
import { catchError, map } from 'rxjs/operators';
import { FnLocalStorageService } from '../../../services/fn-local-storage.service';

@Injectable()
export class FnMenuDataService extends FnLocalStorageService {
	private menuData: FnMenuItemState;
	private menuItemMap:any= {};
	private menuItemDetailMap:any = {};
	private isMenuLoaded = false;
	private activeMenuId = '';
	private activeMenuId$ = new BehaviorSubject<string>('');
  private menuLoadedStatus$ = new Subject<boolean>();
	constructor(private http: HttpClient) {
		super();
	}

	private readonly MENU_ID_KEY = 'id';
	private readonly MENU_ARRAY_KEY = 'menuItemArray';
	private readonly MENU_INFO_KEY = 'detail';
	private readonly MENU_PARENT_ARRAY_KEY = 'parentArray';

	getMenuMapOnId(rootMap: object|any, arrayObject: any[]) {
		if (arrayObject) {
			// tslint:disable-next-line: prefer-for-of
			for (let i = 0; i < arrayObject.length; i++) {
				if (arrayObject[i][this.MENU_ID_KEY] !== 'undefined') {
					rootMap[arrayObject[i][this.MENU_ID_KEY]] = arrayObject[i];
					this.getMenuMapOnId(rootMap, arrayObject[i][this.MENU_ARRAY_KEY]);
				}
			}
		}
	}

	simpleMenuMapOnId(rootMap: object|any, arrayObject: any[], parentKey?: string) {
		if (arrayObject) {
			// tslint:disable-next-line: prefer-for-of
			for (let i = 0; i < arrayObject.length; i++) {
				if (arrayObject[i][this.MENU_ID_KEY] !== undefined) {
					const menuArray = [];
					if (
						parentKey !== undefined &&
						rootMap[parentKey][this.MENU_PARENT_ARRAY_KEY] !== undefined
					) {
						rootMap[parentKey][this.MENU_PARENT_ARRAY_KEY].forEach(
							(value: any) => {
								menuArray.push(value);
							}
						);
					}

					const tempObj = {
						id: arrayObject[i][this.MENU_ID_KEY],
						name: arrayObject[i].name,
						url: arrayObject[i].url,
						len: arrayObject[i][this.MENU_ARRAY_KEY].length,
						showBreadcrum: arrayObject[i].showBreadcrum,
					};
					menuArray.push(tempObj);

					rootMap[arrayObject[i][this.MENU_ID_KEY]] = {};
					//  rootMap[arrayObject[i][this.MENU_ID_KEY]] = menuArray;
					rootMap[arrayObject[i][this.MENU_ID_KEY]][
						this.MENU_INFO_KEY
					] = tempObj;
					rootMap[arrayObject[i][this.MENU_ID_KEY]][
						this.MENU_PARENT_ARRAY_KEY
					] = menuArray;

					this.simpleMenuMapOnId(
						rootMap,
						arrayObject[i][this.MENU_ARRAY_KEY],
						arrayObject[i][this.MENU_ID_KEY]
					);
				}
			}
		}
	}

	ajaxForMenuData(menuId?: string) {
		return this.http
			.get<FnMenuItemState>(
				'https://raw.githubusercontent.com/VasimHayat/mock_data/master/menu.json'
			)
			.pipe(
				// tslint:disable-next-line: no-string-literal
				map((menuData: any) => menuData.menuDataHash.menuData),
				catchError((error) => throwError(error))
			);
	}

	loadMenuData(menuData: FnMenuItemState): Observable<boolean> {
		const returnSub = new Subject<boolean>();
		this.menuData = menuData;
		this.menuItemMap = {};
		this.menuItemMap[menuData.id] = {};
		this.menuItemDetailMap = {};
		this.menuItemDetailMap[menuData.id] = menuData;
		this.simpleMenuMapOnId(this.menuItemMap, menuData.menuItemArray);
		this.getMenuMapOnId(this.menuItemDetailMap, menuData.menuItemArray);

		setTimeout(() => {
			// tslint:disable-next-line: triple-equals
			if (this.activeMenuId.length == 0) {
				this.activeMenuId = menuData.menuItemIDArray[0];
				this.activeMenuId$.next(this.activeMenuId);
			}
			this.isMenuLoaded = true;
			returnSub.next(this.isMenuLoaded);
      this.menuLoadedStatus$.next(this.isMenuLoaded);
			returnSub.complete();
		});
		return returnSub;
	}

	getMenuData(): FnMenuItemState {
		return this.menuData;
	}

	getRootMenuId(): string {
		return this.getMenuData().id;
	}

	getActiveMenuId(): string {
		return this.activeMenuId;
	}

	setActiveMenuId(menuId: string) {
		this.activeMenuId = menuId;
		this.setItem('selected_menu', menuId);
		this.activeMenuId$.next(this.activeMenuId);
	}

	getMenuItemMap() {
		return this.menuItemMap;
	}

	getMenuDetailItemMap() {
		return this.menuItemDetailMap;
	}

	getMenuItemById(menuId: string): FnMenuState {
		return this.getMenuDetailItemMap()[menuId];
	}

	getActiveMenuItem(): Observable<object> {
		return of(this.getMenuDetailItemMap()[this.getActiveMenuId()]);
	}

	getActiveMenuId$(): BehaviorSubject<string> {
		return this.activeMenuId$;
	}

	getMenuStatus() {
		return this.isMenuLoaded;
	}

  getMenuLoadedStatus$(){
    return this.menuLoadedStatus$;
  }

	// getMenuData(menuId: string) {
	//     const returnObs = new Subject();
	//     this.http.get('dummy.menu.json').subscribe(
	//         (resp: FnMenuItemState) => {
	//             returnObs.next(resp);
	//             returnObs.complete();
	//         },
	//         error => {
	//             returnObs.error(error);
	//             returnObs.complete();
	//         }
	//     );

	// }
}
